import { NDP_NDR_METADATA, NDP_NDR_SWITCH_DATE } from "@config/ndrConstants";

export const getNdpNdrMeta = (now = new Date()) => {
  const switchDate = new Date(NDP_NDR_SWITCH_DATE);

  return now >= switchDate ? NDP_NDR_METADATA.ndr : NDP_NDR_METADATA.ndp;
};
